import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import type { Observable } from 'rxjs';
import { map } from 'rxjs';
import type { ModalityTypeInterface } from 'src/app/shared/models/modality-type.interface';

@Injectable()
export class AdminModalityTypeService {
  constructor(private readonly apollo: Apollo) { }

  getModalityTypes(): Observable<ModalityTypeInterface[]> {
    return this.apollo.query<GetModalityTypesReponse>({
      query: gql`query getAdminModalityTypes {
        modalityTypes(order: { value: ASC }) {
          id
          value
        }
      }`
    }).pipe(map(res => res.data.modalityTypes));
  }
}

export interface GetModalityTypesReponse {
  modalityTypes: ModalityTypeInterface[];
}
